import axios from 'axios';
axios.defaults.withCredentials = true;
import { fetchToken } from '../fetchToken';
const API_URL = process.env.EMAILS_API_URL;
import { logError } from '../../taskpane/utils/request';
import { removeEmptyStrings } from '../../taskpane/utils/stringUtils';

export const getTime = async (salesforceEmailIds, emailId, ownerEmail) => {
  const token = await fetchToken();
  const config = {
    method: 'GET',
    url: `${API_URL}time/records?ids=${salesforceEmailIds.join()}${emailId ? `&emailId=${emailId}` : ''}${ownerEmail ? `&ownerEmail=${ownerEmail}` : ''}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    return await axios(config);
  } catch (e) {
    logError(e);
    throw e;
  }
};

export const getTimeConfig = async () => {
  const token = await fetchToken();
  const config = {
    method: 'GET',
    url: `${API_URL}time/globalconfig`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    return await axios(config);
  } catch (e) {
    logError(e);
    throw e;
  }
};

export const getTimekeeperOptions = async () => {
  const token = await fetchToken();
  const config = {
    method: 'GET',
    url: `${API_URL}time/timekeepers`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    return await axios(config);
  } catch (e) {
    logError(e);
    throw e;
  }
};

export const addTime = async (timeRecords, exchangeId, ownerEmail) => {
  const token = await fetchToken();
  const config = {
    method: 'PUT',
    url: `${API_URL}time/records${ownerEmail ? `?ownerEmail=${ownerEmail}` : ''}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    data: {
      exchangeId,
      timeRecords,
    },
  };

  try {
    return await axios(config);
  } catch (e) {
    logError(e);
    throw e;
  }
};

/**
 * Deletes time records for a specific emailId and timeRecordId from dynamo.
 * @param {string} salesforceEmailId
 * @param {string} timeRecordId
 * @param {string} graphEmailId
 * @param {string} ownerEmail
 * @return {object} HTTP Response
 */
export const deleteDynamoTimeRecord = async (salesforceEmailId, timeRecordId, graphEmailId, ownerEmail) => {
  const token = await fetchToken();

  const config = {
    method: 'DELETE',
    url: `${API_URL}time/records?graphEmailId=${graphEmailId}&salesforceEmailId=${salesforceEmailId}&timeRecordId=${timeRecordId}${ownerEmail ? `&ownerEmail=${ownerEmail}` : ''}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    return await axios(config);
  } catch (e) {
    logError(e);
    throw e;
  }
};

export const checkBillingRules = async (timeEntry) => {
  // clean out out errors/warnings
  delete timeEntry.errorRules;
  delete timeEntry.warningRules;
  delete timeEntry.errorIdsEncoded;
  delete timeEntry.warningIdsEncoded;
  delete timeEntry.fixLater;
  timeEntry = removeEmptyStrings(timeEntry);
  const token = await fetchToken();
  const config = {
    method: 'PUT',
    url: `${API_URL}time/records/rules`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    data: {
      timeEntry,
    },
  };
  return await axios(config);
};

/**
 * Get billing codes from salesforce
 * @param {array} matterIds
 * @return {object} HTTP Response
 */
export const getBillingCodeSets = async (matterIds) => {
  const token = await fetchToken();
  const config = {
    method: 'GET',
    url: `${API_URL}time/billingcodesets?matterIds=${matterIds.join()}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    return await axios(config);
  } catch (e) {
    logError(e);
    throw e;
  }
};
